import BasePage from "components/basePage/BasePage";
import GroupFilters from "components/groupFilters/GroupFilters";
import moment from "moment";
import React, { useState, useEffect } from "react";
import {
  getPageSpeedReport,
  getSearchConsoleReport,
  getWebVitalsMetrics,
  getNotes
} from "services/requests";
import "./GroupsPerfomance.scss";
import Loading from "components/loading/Loading";
import ErrorMessage from "components/errorMessage/ErrorMessage";
import {
  googleSearchConsoleDataTypes,
  getPageSpeedDataTypes,
} from "constants/chartDataTypes";
import ChartsContainer from "components/chartsContainer/ChartsContainer";
import {
  buildArrayOfDates,
  buildFiltersURL,
  getParameterFromURL,
  showToast,
  formatDate,
  formatNumber,
  perc,
} from "services/helper";
import { useNavigate } from "react-router-dom";
import Button from "components/button/Button";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import {
  getTip,
  getTipsObj,
  getTotalsObj,
  tip,
  tipBody,
  tipFooter,
  tipHead,
  isClickOrImpression,
  formatValue,
  isWVStatus,
} from "./tipHelper";
import SearchInput from "./components/SearchInput";
import SelectedGroups from "./components/SelectedGroups";
import { chartColors, webVitalsColors } from "./chartColors";
import StatusAndGroupSelector from "./components/StatusAndGroupSelector";


//Web Vitals Status
const WVStatusList = [
  { label: "Aprovadas", value: "good" },
  { label: "Melhorias necessárias", value: "needsImprovements" },
  { label: "Reprovadas", value: "poor" },
];
const searchConsole = "Google Search Console";

function fillObjGroup(value) {
  const obj = {};
  ['cls', 'fcp', 'fid', 'lcp', 'inp', 'ttfb'].forEach(key => obj[key] = value) //modify
  return obj;
}

function GroupsPerfomance() {
  //NAVIGATION
  const navigate = useNavigate();
  //STATE
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [periodType, setPeriodType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchedGroups, setSearchedGroups] = useState(null);
  const [charts, setCharts] = useState([]);
  const [WVCharts, setWVCharts] = useState([]); //Stands for "Web Vitals Charts"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchText, setSearchText] = useState("");
  const [WVMetrics, setWVMetrics] = useState([]); //Stands for "Web Vitals Metrics"
  const [selectedCheckbox, setSelecteCheckbox] = useState("groupDetails");
  const [groupDetails, setGroupDetails] = useState(null);
  const [WVStatus, setWVStatus] = useState(WVStatusList[0].value); //Stands for "Web Vitals Status"
  const [shouldSearchAgain, setShouldSearchAgain] = useState(false);
  const [groupPages, setGroupPages] = useState(fillObjGroup(0));
  const [selectedAverage, setSelectedAverage] = useState(fillObjGroup(true));
  const [showNotes, setShowNotes] = useState(false);
  const [notes, setNotes] = useState([]);
  const [notesOrigin, setNotesOrigin] = useState('TODAS');
  const [dataSource, setDataSource] = useState(
    getParameterFromURL("dataSource") || searchConsole
  );
  //OTHERS
  const isMonth = periodType === "MONTH";
  const isSearchConsole = dataSource === searchConsole;
  const hasSelectedGroups = selectedGroups?.length > 0;
  const validDates = moment(startDate).isValid() && moment(endDate).isValid();
  const comparingByWMStatus = selectedCheckbox === "compareGroup"; //Stands for "Comparing By Web Vitals Status"
  const dataTypes = isSearchConsole
    ? googleSearchConsoleDataTypes
    : getPageSpeedDataTypes(comparingByWMStatus ? WVStatus : null);

  useEffect(() => {
    const loadWVMetrics = !isSearchConsole && WVMetrics?.length === 0;
    if (loadWVMetrics) getWebVitalsMetrics().then((data) => setWVMetrics(data));
    else cleanCharts();
  }, [WVMetrics, dataSource]);

  useEffect(() => {

    let newSearchedGroups = {};
    if (searchedGroups && !shouldSearchAgain) {
      Object.keys(searchedGroups).forEach((id) => {
        const found = selectedGroups.find((g) => g?.id === parseInt(id));
        if (found) newSearchedGroups[id] = searchedGroups[id];
      });
      setSearchedGroups(newSearchedGroups);
    }
  }, [selectedGroups, selectedCheckbox, WVStatus, groupDetails, groupPages, selectedAverage]);

  useEffect(() => {
    if (searchedGroups) {
      buildAllGraphs();
    }
  }, [searchedGroups]);

  useEffect(() => {
    if(showNotes) {
      let _startDate = moment(startDate).format("YYYY-MM-DD");
      let _endDate = moment(endDate).format("YYYY-MM-DD");
      getNotes({startDate: _startDate, endDate: _endDate, type: isSearchConsole? 'GSC': 'PAGESPEED', notesOrigin})
        .then((data) => {
          setNotes(data.results);
        })
        .catch((error) => {
            console.log(error)
            showToast(
              "Não foi possível carregar os dados das notas, tente novamente mais tarde."
            );
          }
        );
    }
  }, [showNotes, notesOrigin, startDate, endDate, isSearchConsole]);

  function buildAllGraphs() {
    let subtitles = {};
    dataTypes.forEach(type => {
      let subtitle = getDataTypeGraph(type, subtitles);
      if(type !== WVStatus) {
        subtitles[type] = subtitle;
      } else {
        if (!isSearchConsole && comparingByWMStatus)
          setWVCharts(getWVCharts(subtitle));
      }
    });
    setCharts(getCharts(subtitles));   
    if (!isSearchConsole && !comparingByWMStatus) {
      const WVSubtitles = formatOneGroup('status');
      setWVCharts(getWVCharts(WVSubtitles));
    }
  }

  function getDataTypeGraph(type) {
    let subtitle;
    if(!isSearchConsole && selectedAverage[type] !== undefined &&  !selectedAverage[type]) { // graphs per page of WV
      return formatOneGroup(type);
    } else { // graphs per average, performance, status or for search console
      subtitle = getSubtitles(type);
      let datesRange = getDatesRange();
      datesRange?.forEach((date) => {
        let newLine =  getDataPerDate(date, type);
        subtitle.push(newLine);
      });
     return subtitle;
    }       
  }

  function getDataPerDate(date, type) {
    let total = getTotalsObj(type);
    let tip = getTipsObj(
      formatDate(isMonth, date, !isMonth),
      getEndOfTheWeek(date)
    );
    let newLine = getNewDataLines(date, type);

    //It passes by each group
    Object.keys(searchedGroups).forEach((id) => {
      const {line, newTip, newTotal} = buildNewLinePerGroup(id, type, date);
      newLine.push(line, null);
      tip += newTip;
      total += newTotal;
    });          
    tip += addTipFooter(total, type);
    addTipsInLines(newLine, tip);
    return newLine;
  }

  function buildNewLinePerGroup(id, type, date) {
    const group = searchedGroups[id];
    const item = findItemByDate(group, date); // needed to check if date has data
    if(item) {
      if(type === 'cls' || type === 'fcp' || type === 'fid' || type === 'lcp' || type === 'inp' || type === 'ttfb') { //modify
        if(item[type]?.average && item[type]?.count !== 0) {
          return {
            line: item[type]?.average,
            newTip: fillTips(id, item, type)
          }    
        } else {
          return {
            line: null,
            newTip: fillTips(id, item, type)
          }
        }
      } else {
        return {
          line: item[type],
          newTip: fillTips(id, item, type),
          newTotal: isClickOrImpression(type) && item[type]
        }
      }
    } else {
      return {
        line: null,
        tip: `<div style="display: flex;"></div>`
      }
    }
  }

  function addTipsInLines(lines, tips, jump = 2) {
    for (let i = jump; i < lines?.length; i += 2) {
      lines[i] = tips;
    }
  }

  function findItemByDate(group, date) {
    return group?.find(
      (item) =>
        item?.date === date || item?.month === date || item?.week === date
    );
  }

  function formatOneGroup(type) {
    let WVSubtitles = [["Date", ...getWVHeader()]];
    const group = searchedGroups[type === 'status' ? groupDetails : groupPages[type]];
    let datesRange = getDatesRange();
    let emptyTip = `<div style="display: flex;"></div>`;
    datesRange?.forEach((date) => {
      let item = findItemByDate(group, date);
      if(item) {
        let date = item?.date || item?.month || item?.week;
        let good = item?.good;
        let improv = item?.needsImprovements;
        let poor = item?.poor;
        let total = item?.totalCwv;
        if(type !== 'status') {
          improv = item[type]?.needsImprovement;
          good = item[type]?.good;
          poor = item[type]?.poor;
          let sum = good + improv + poor;
          good = Math.round(perc(good, sum));
          improv = Math.round(perc(improv, sum));
          poor = Math.round(perc(poor, sum));
          total = sum;
        }
        let tipHTML = getTip(
          tipHead,
          formatDate(isMonth, date, true),
          getEndOfTheWeek(date)
        );
        tipHTML += getTip(tipBody, {
          label: "Good",
          color: "green",
          value: `${good}%`,
        });
        tipHTML += getTip(tipBody, {
          label: "Needs Improvement",
          color: "#E5BB00",
          value: `${improv}%`,
        });
        tipHTML += getTip(tipBody, {
          label: "Poor",
          color: "red",
          value: `${poor}%`,
        });
        tipHTML += getTip(tipFooter, formatNumber(total));
  
        WVSubtitles.push([
          formatDate(isMonth, date),
          good,
          tipHTML,
          improv,
          tipHTML,
          poor,
          tipHTML,
        ]);
      } else {
        WVSubtitles.push([
          formatDate(isMonth, date),
          null,
          emptyTip,
          null,
          emptyTip,
          null,
          emptyTip
        ]);
      }
    });
    return WVSubtitles;
  }

  function fillTips(groupId, item, type) {
    //item = getItemValues(item);
    const index = selectedGroups.findIndex((g) => g?.id === parseInt(groupId));
    const group = { ...selectedGroups[index], color: chartColors[index] };
    let value = isWVStatus(type)
      ? `${item[type]}% de ${formatNumber(item.totalCwv)}`
      : type === 'cls' || type === 'fcp' || type === 'fid' || type === 'lcp' || type === 'inp' || type === 'ttfb'
       ? item[type]?.average
       : item[type];

    return getTip(tipBody, {
      label: `${group?.id} - ${group?.name}`,
      color: group?.color,
      value: formatValue(type, value),
    });
  }

  function addTipFooter( totals, type) {
    const value = isClickOrImpression(type)
      ? formatNumber(totals)
      : null;
      return getTip(tipFooter, value);
  }

  function getNewDataLines(date, type) {
    date = formatDate(isMonth, date);
    if (isSearchConsole || type === 'performance' || type === WVStatus) {
      return [date]
    } else {
      return [date, ...addWebVitalsMetrics(type)]
    }
  }

  function addWebVitalsMetrics(type) {
    let metrics = [];
    let limits = WVMetrics?.find(
      (item) => item?.metric === type?.toUpperCase()
    )?.limits;

    limits?.forEach((item, i) => {
      let newItem = null;
      let tooltipText = "";
      if (i === 0) {
        newItem = item?.start - (limits[1]?.end - limits[2]?.end);
        tooltipText = `Good ${limits[2]?.end}`;
      } else if (i === 1) {
        newItem = item?.end - limits[2]?.end;
        tooltipText = `Needs improvement ${item?.end}`;
      } else {
        newItem = item?.end;
        tooltipText = `Poor ${limits[0]?.start}+`;
      }
      metrics.push(newItem, tooltipText);
    });
    return metrics;
  }

  function getSubtitles(type) {
    let subtitles = [];
    if(type !== 'status' && type !== WVStatus) {
      subtitles = [getLineHeader(type)];
    } else {
      subtitles = [getLineHeader()];
    }
    return subtitles;
  }

  function getLineHeader(type) {
    let header = ["Date"];
    if (!isSearchConsole && type !== "performance" && type) {
      header.push(...getWVHeader());
    }

    selectedGroups.forEach((group) => {
      header.push(`${group?.id} | ${group?.name}`);
      header.push(tip); //Later, this position will hold the tooltip HTML
    });

    return header;
  }

  function getWVHeader() {
    return ["Good", tip, "Needs Improvement", tip, "Poor", tip];
  }

  function getCharts(subtitles) {
    let types = dataTypes;
    if (!isSearchConsole) types = types?.filter((type) => type !== "status");

    return types?.map((type) => {
      const isComboChart =
        !isSearchConsole && type !== "performance" && type !== "status" && selectedAverage[type];
      const config = {
        data: subtitles[type],
        dataType: type,
        isStacked: true,
      };

      if (isComboChart) {
        const series = { type: "area", areaOpacity: 0.3, lineWidth: 0 };
        config.chartType = "ComboChart";
        config.options = {
          colors: [...webVitalsColors, ...chartColors],
          seriesType: "line",
          isStacked: true,
          lineWidth: 2.5,
          title: `${type.toUpperCase()} ${type === "cls" ? "(%)" : "(ms)"}`,
          series: {
            0: series,
            1: series,
            2: { ...series, areaOpacity: 0.015 },
            4: { type: "bar"}
          },
          chartArea: {
            backgroundColor: {
              fill: "red",
              fillOpacity: 0.2,
            },
          },
        };
      } else {
        const isAreaChart = isClickOrImpression(type);
        config.chartType = isAreaChart ? "AreaChart" : "LineChart";
        config.options = { colors: isSearchConsole || type === 'performance' ? chartColors : ["green", "#E5BB00", "red"], isStacked: true };
      }
      return config;
    });
  }

  function getWVCharts(WVSubtitles) {
    return [
      {
        data: WVSubtitles,
        dataType: "status",
        chartType: "LineChart",
        isStacked: true,
        options: {
          colors: comparingByWMStatus
            ? chartColors
            : ["green", "#E5BB00", "red"],
        },
      },
    ];
  }

  function getDatesRange() {
    const oldestDate = getDate(true);
    const mostRecentDate = getDate();
    return buildArrayOfDates(oldestDate, mostRecentDate, periodType);
  }

  function getDate(oldest) {
    let ret = null;
    Object.keys(searchedGroups).forEach((groupId, index) => {
      const group = searchedGroups[groupId];
      const position = oldest ? 0 : group?.length - 1;
      const item = group[position];
      const date = item?.month || item?.date || item?.week;
      if (
        index === 0 ||
        (oldest && moment(date).isBefore(ret)) ||
        (!oldest && moment(date).isAfter(ret))
      )
        ret = date;
    });
    return ret;
  }

  function getEndOfTheWeek(date) {
    if (periodType === "WEEK")
      return formatDate(false, moment(date).add(6, "days"), true);
    return null;
  }

  function isGroupSelected(groupId, returnIndex) {
    if (returnIndex) return selectedGroups?.findIndex((g) => g?.id === groupId);
    else return selectedGroups?.find((g) => g?.id === groupId);
  }

  function onGroupSelection(group) {
    setSearchText("");
    if (!isGroupSelected(group?.id)) {
      const max = chartColors?.length;
      if (selectedGroups?.length < max) {
        let newSelectedGroups = [...selectedGroups, group];
        newSelectedGroups.sort((a, b) => a?.id - b?.id);
        updatesDetailedPageGroup(newSelectedGroups[0]?.id);
        showSearchAgainWarning();
        setSelectedGroups(newSelectedGroups);
      } else
        showToast(`O número máximo de seleção de grupos é ${max}`, "error");
    } else showToast(`Este grupo já foi selecionado`, "warning");
  }

  function updatesDetailedPageGroup(firstID) {
    if (!isSearchConsole) {
      if(firstID !== groupDetails) setGroupDetails(firstID) ;
      if(firstID !== groupPages) setGroupPages({...groupPages, ...fillObjGroup(firstID)});
    }  
  }

  function showSearchAgainWarning() {
    let message = `Pressione "Buscar" para obter os dados do novo grupo selecionado.`;
    if (!shouldSearchAgain && searchedGroups) {
      setShouldSearchAgain(true);
      showToast(message, "warning");
    } else if (shouldSearchAgain) showToast(message, "warning");
  }

  function triggerSearch() {
    if (hasSelectedGroups) {
      setLoading(true);
      let _startDate = moment(startDate).format("YYYY-MM-DD");
      let _endDate = moment(endDate).format("YYYY-MM-DD");
      let request = null;
      const params = {
        groups: selectedGroups,
        startDate: _startDate,
        endDate: _endDate,
        periodType,
      };

      if (isSearchConsole) request = getSearchConsoleReport(params);
      else request = getPageSpeedReport(params);
      request
        .then((data) => {
          setSearchedGroups(data);
          if (shouldSearchAgain) setShouldSearchAgain(false);
        })
        .catch(() =>
          setError(
            "Não foi possível carregar os dados, tente novamente mais tarde."
          )
        )
        .finally(() => {
          setLoading(false);
          let url = buildFiltersURL(periodType, _startDate, _endDate);
          url = url.concat(`groups=${getGroupsIDs()}&dataSource=${dataSource}`);
          navigate(url); //Updates browser URL
        });
    } else showToast("Selecione ao menos um grupo.", "error");
  }

  function getGroupsIDs() {
    return selectedGroups?.map((g) => g?.id).join();
  }

  function onChartTypeChange(event, type) {
    const index = charts?.findIndex((item) => item?.dataType === type);
    charts[index].chartType = event?.target?.value;
    setCharts([...charts]);
  }

  function cleanCharts() {
    setWVCharts([]);
    setCharts([]);
    setSearchedGroups(null);
  }

  function changeDataSource(newSource) {
    const isPageSpeed = newSource === "PageSpeed";
    const updateGroupDetails = isPageSpeed && selectedGroups.length > 0;
    cleanCharts();
    if (updateGroupDetails) {
      setGroupDetails(selectedGroups[0]?.id);
      setGroupPages({...groupPages, ...fillObjGroup(selectedGroups[0]?.id)});
    } 
    if (isPageSpeed) setPeriodType("DAY");
    setSelecteCheckbox("groupDetails");
    setDataSource(newSource);
  }

  return (
    <BasePage
      title="Desempenho dos grupos"
      className="groups-performance-screen"
    >
      <GroupFilters
        onChangePeriod={(period) => setPeriodType(period)}
        onStartDateChange={(newStartDate) => setStartDate(newStartDate)}
        onEndDateChange={(newEndDate) => setEndDate(newEndDate)}
        weekAvailable={true}
      />
      <div className="search-container">
        <SearchInput
          text={searchText}
          onSearchChange={(text) => setSearchText(text)}
          onGroupSelection={onGroupSelection}
        />

        <FormControl className="data-source-select">
          <InputLabel>Fonte dos dados</InputLabel>
          <Select
            native
            id="grouped-native-select"
            label="Fonte dos dados"
            onChange={(event) => changeDataSource(event.target.value)}
            size="small"
            value={dataSource}
          >
            <option>{searchConsole}</option>
            <option>PageSpeed</option>
          </Select>
        </FormControl>
        <FormControl className="show-notes-select" style={{minWidth: '150px'}}>
          <InputLabel>Mostrar notas</InputLabel>
          <Select
            native
            id="show-notes-select"
            label="Mostrar notas"
            onChange={(event) => setShowNotes(event.target.value === "Sim")}  
            size="small"
            value={showNotes? "Sim": "Não"}
          >
            <option>Não</option>
            <option>Sim</option>
          </Select>
        </FormControl>

        <FormControl className="notes-origin-select" style={{minWidth: '150px'}}>
          <InputLabel>Origem Notas</InputLabel>
          <Select
            native
            id="show-notes-select"
            label="Origem Notas"
            onChange={(event) => setNotesOrigin(event.target.value)}  
            size="small"
            value={notesOrigin}
          >
            <option>TODAS</option>
            <option>TEAM</option>
            <option>GOOGLE</option>
          </Select>
        </FormControl>

        <Button
          onClick={triggerSearch}
          className="trigger-search-button"
          text="Buscar"
        />
      </div>

      

      <SelectedGroups
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
        setGroupPages={setGroupPages}
        isGroupSelected={isGroupSelected}
        setGroupDetails={setGroupDetails}
        onUncheck={(newGroups) => {
          if (newGroups?.length === 0) cleanCharts();
          else { 
            setGroupDetails(newGroups[0]?.id);
            setGroupPages(fillObjGroup(newGroups[0]?.id))
          }
        }}
      />
      <Loading visible={loading} />
      {!loading && <ErrorMessage message={error} />}

      {hasSelectedGroups && !loading && validDates && error?.length === 0 && (
        <>
          <ChartsContainer
            charts={charts}
            notes={notes}
            showNotes={showNotes}
            periodType={periodType}
            onChartTypeChange={onChartTypeChange}
            visible={true}
            selectedAverage={selectedAverage}
            setSelectedAverage={setSelectedAverage}
            groupPages={groupPages}
            setGroupPages={setGroupPages}
            selectedGroups={selectedGroups}
          />
          {!isSearchConsole && charts.length > 0 && (
            <>
              <StatusAndGroupSelector
                selectedGroups={selectedGroups}
                setGroupDetails={setGroupDetails}
                setWebVitalsStatus={setWVStatus}
                wvStatusList={WVStatusList}
                groupDetails={groupDetails}
                WVStatus={WVStatus}
                selectedCheckbox={selectedCheckbox}
                setSelecteCheckbox={setSelecteCheckbox}
              />
              <ChartsContainer config={WVCharts} visible={true} groupDetails={groupDetails}/>
            </>
          )}
        </>
      )}
    </BasePage>
  );
}

export default GroupsPerfomance;
